<template>
  <v-row align="center" dense>
    <v-col cols="11">
      <v-row dense no-gutters class="pa-0 ma-0" v-if="bossItems.length === 0">
        <v-col cols="12">
          Руководители не заданы
        </v-col>
      </v-row>
      <v-row dense no-gutters class="pa-0 ma-0 justify-start flex" v-else>
        <v-col
          v-for="(bossItem) in bossItems"
          :key="bossItem.EMP_UUID"
        >
          <v-chip
            outlined
            label
            close
            small
            color="blue-grey darken-4"
            class="black--text"
            :close-icon="mode=='edit' ? 'mdi-account-minus' : ''"
            @click:close="delBoss(bossItem)"
            @click="onBossClick(bossItem)"
          >
            <v-avatar left>
              <v-icon
                small
              > mdi-account</v-icon>
            </v-avatar>
            {{ bossItem.USR_FIO }}
          </v-chip>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="1" class="align-center justify-center">
      <v-btn
        color="pink"
        x-small
        dark
        bottom
        right
        fab
        v-if="mode=='edit'"
        @click="addBoss"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-col>
    <user-select-boss-dialog
      v-model="showAddBossDialog"
      :user="user"
      @onSelectedUser="doUpdate"
    />
  </v-row>
</template>

<script>
import UserSelectBossDialog from '@/components/modules/org/structure/staff/components/userSelectBossDialog'

export default {
  name: 'userBossList',
  props: {
    user: {
      type: Object,
      default: function () {
        return {}
      }
    },
    mode: {
      type: String,
      default: null
    }
  },
  components: {
    UserSelectBossDialog
  },
  data: () => ({
    showAddBossDialog: false
  }),
  computed: {
    bossItems: {
      get: function () {
        if (this.user && this.user.BOSSLIST) {
          return this.user.BOSSLIST
        }
        return []
      }
    }
  },
  methods: {
    clearForm () {
    },
    onBossClick (item) {
      this.$emit('onBossSelected', item)
    },
    addBoss () {
      console.log('Called add Boss for user ', this.user)
      this.showAddBossDialog = true
    },
    doUpdate (data) {
      // this.showAddBossDialog = false
      this.$emit('onUserBossListUpdate', data)
    },
    delBoss (data) {
      this.$emit('onUserBossDelete', data)
    }
  }

}
</script>
